//import {Const} from "../stores/Constants";
import {store} from "../stores/mainStore";

export class Gleam {
	static openUrl = in_url => {
		const url = in_url || 'gleam.io/pvJQw/7500-game-night-giveaway-test';
		console.log('GLEAM try to open url', url);

		// open in separate window
		if(store.isDev) {
			window.open('https://'+ url)
		} else {
			window.WrapperApp.postMessage('open-url?url='+url)
		}

		/* // open in in-app with Close button
		store.showExternalPage = 'https://'+ url; */
	}

	static promos = [];
	static availableInLobby = false;
	static availableInMatch = false;
	static checkPromos = (json, folder) => {
		if(json.gleam) {
			Gleam.qaDate = !!json.qaCurrentDate ? new Date(json.qaCurrentDate) : false;
			Gleam.availableInLobby = json.gleamInLobby.includes(store.deviceType) || json.gleamInLobby === 'ON';
			Gleam.availableInMatch = json.gleamInMatch.includes(store.deviceType) || json.gleamInMatch === 'ON';
			Gleam.promos = json.gleam.map(v => { return {
				image: folder + json.gleamPath + v.image,
				url: v.url,
				start: new Date(v.start),
				end: new Date(v.end)
			}});
			console.log('GLEAM :: t =', store.deviceType, 'av l =', Gleam.availableInLobby, 'm =', Gleam.availableInMatch, 'promos =', Gleam.promos)
		}
	}
	static qaDate = null; 
	static checkDate = promo => {
		const now = Gleam.qaDate || new Date();
		return now >= promo.start && now < promo.end;
	}
	static getActivePromo = () => {
		return Gleam.promos.length === 0 ? null :
			Gleam.promos.find(p => Gleam.checkDate(p))
	}
}